export default __webpack_public_path__ + "static/media/empty.7b46c105.svg";